module.exports = __webpack_public_path__ + "img/logo.b7736e2d.png";